import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';

export const Footer: FC<{
  onClose: VoidFunction;
  onDone: VoidFunction;
}> = ({ onClose, onDone }) => {
  return (
    <>
      <Button onClick={onClose} data-cy="filter-drawer.cancel">
        {useTranslation('cancel')}
      </Button>
      <Button type="primary" onClick={onDone} data-cy="filter-drawer.done">
        {useTranslation('done')}
      </Button>
    </>
  );
};
